import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { TextCalloutEntry } from "frontend/contentful/schema/blocks";
import {
  TextCalloutItem,
  TextCalloutProps,
} from "design-system/components/blocks/text-callout/text-callout";
import { useContentful } from "frontend/hooks/use-contentful";
import { TextCalloutOptions } from "./text-callout.contentful";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";

export const createTextCalloutProps = createContentfulProps<
  TextCalloutEntry,
  TextCalloutProps,
  TextCalloutOptions
>(({ entry, options, createEditAttributes }) => {
  const { getEntries } = useContentful();
  const headerAbove = options?.headerAbove || false;
  const items: Array<TextCalloutItem> = [];

  getEntries(entry.fields.textCalloutItems)?.forEach((item) => {
    const description = item.fields.description && (
      <RenderContentfulRichText
        document={item.fields.description}
        disableParagraphs
      />
    );

    if (description) {
      items.push({
        content: description,

        editAttributes: {
          content: createEditAttributes({
            entry: item,
            fieldId: "description",
          }),
        },
      });
    }
  });

  const props: TextCalloutProps = {
    titleContent: entry.fields.title && (
      <RenderContentfulRichText
        document={entry.fields.title}
        disableParagraphs
      />
    ),
    align: entry.fields.alignment,
    items,
    HeadingLevel: headerAbove ? "h3" : "h2",

    editAttributes: {
      titleContent: createEditAttributes({ entry, fieldId: "title" }),
    },
  };

  return props;
});
